module.exports = __webpack_public_path__ + "fonts/review-connector-beta.png!static";